module.exports = __webpack_public_path__ + "static/media/header_twitter_icon.72a023ab.svg";